module.exports = __webpack_public_path__ + "img/02.22cec6c5.png";